import { useMutation } from "urql";

import { CreateOfferLetterDocument } from "../../../graphql/generated.ts";

export const useCreateOfferLetter = () =>
  useMutation(CreateOfferLetterDocument);
